import { useTranslation } from 'react-i18next';

import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';

import { StandardSmallModalBox } from '@frontend/features/common/utils/modals';

import { Form } from './Form';
import { useGetClientById } from '../../queries';

interface EditClientModalProps {
  open: boolean;
  onClose: () => void;
  clientId?: string;
}

export const EditClientModal = ({ open, onClose, clientId }: EditClientModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { data } = useGetClientById({
    id: clientId,
  });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('clients.edit.title')}>
      <StandardSmallModalBox display="flex" flexDirection="column" gap={theme.spacing(2)}>
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <PersonIcon color="disabled" />
            <Typography id="create-client-modal-title" variant="h6" component="h2">
              {t('clients.edit.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form onClose={onClose} data={data} />
      </StandardSmallModalBox>
    </Modal>
  );
};
